import { render, staticRenderFns } from "./TagFire.vue?vue&type=template&id=210b7fa0&scoped=true"
import script from "./TagFire.vue?vue&type=script&lang=js"
export * from "./TagFire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210b7fa0",
  null
  
)

export default component.exports